import { formatDateToET } from '@terminal/modules/impacted-companies/components/utils';
import { formatPercentageNumber } from '@terminal/widgets/earnings/utils/utils';

import styles from './EarningsDateLabel.module.scss';

export interface EarningsDateLabelProps {
  date?: string;
  label: string;
  oneDayReaction?: string;
  price?: number;
}

export const EarningsDateLabel = ({
  date,
  label,
  oneDayReaction,
  price,
}: EarningsDateLabelProps) => {
  return (
    <div className={styles.earningsReleaseDate}>
      <div className={styles.dateWrapper}>
        <div className={styles.date}>{label} </div>
        {date && (
          <div className={styles.value}>{formatDateToET(new Date(date))}</div>
        )}
      </div>
      {!!oneDayReaction && !!price && (
        <div className={styles.dateWrapper}>
          <div className={styles.date}>{oneDayReaction} </div>
          <div className={styles.value}>
            {price &&
              formatPercentageNumber({
                value: price,
                includePercentSign: true,
                addPlus: true,
              })}
          </div>
        </div>
      )}
    </div>
  );
};
